// MODAL
export const OPEN_MODAL = 'open-modal';
export const CHANGE_APPROVER = 'change-approver';
export const SUBMIT_REQUEST = 'submit-request';
export const CANCEL_REQUEST = 'cancel-request';

// TOOLTIP
export const OPEN_TOOLTIP = 'open-tooltip';
